import { FormattedMessage } from "react-intl";

const AtlassianGuardPremium = () => (
    <div>
        <h2>
            <FormattedMessage
                id="JiraServiceManagementPricingPageTeam24.features.atlassianGuardPremium.title"
                defaultMessage="Atlassian Guard Premium (Data classification, threat detections, content scanning)"
            />
        </h2>

        <p>
            <FormattedMessage
                id="JiraServiceManagementPricingPageTeam24.features.atlassianGuardPremium.body"
                defaultMessage="Guard your top-priority projects with our most advanced security capabilities and stop threats before they become incidents."
            />
        </p>
    </div>
);

export default AtlassianGuardPremium;
